<template>
<div @touchmove="stopScroll" :class="{'carouselScreen': (isMobileDevice && isLandscape)}">
    <div ref="carouselContainer" :style="containerStyle" class="carousel" @touchmove="moveTouch" @touchstart="startTouch" @touchend="moveStop" @touchleave="mouseLeave" @mousedown="moveStart" @mouseup="moveStop" @mouseout="mouseLeave" @mouseover="mouseOver">
        <div ref="carouselSlider" class="image-container" :style="sliderStyle">
            <div class="images" v-for="(slide, index) in slideList" v-bind:key="index" :style="imageStyle(slide)" v-if="checkProgressiveReveal(index)"></div>
        </div>
        <transition name="fade">
            <div>
                <div v-if="showFullscreen && isFullScreenSupported" v-on:click="switchFullScreen" class="fullscreenButton">
                    <img src="../assets/icons/fullscreen.svg">
                </div>
                <div v-if="isLeftArrowVisible" class="arrowButtonLeft" v-on:click="changeSlide(currentSlide - 1);">
                    <img src="../assets/icons/arrow.svg">
                </div>
                <div v-if="isRightArrowVisible" class="arrowButtonRight" v-on:click="changeSlide(currentSlide + 1);">
                    <img src="../assets/icons/arrow.svg">
                </div>
            </div>
        </transition>
    </div>
</div>
</template>

<script>

import NavigatorUtils from "../javascript-classes/utils/navigator";

function isFullScreen() {
    return document.mozFullScreen || document.webkitIsFullScreen || document.fullScreen || document.isFullScreen
}

export default{
    props: {
        presentation: {},
        slideList: {},
        syncSlideNum: {},
        syncSlide: {},
        progressiveReveal: {}
    },

    data () {
        return {
            leftLocation: 0,
            mouseLocation: 0,
            mouseDown: false,
            
            showFullscreen: false,
            showArrows: false,
            fullscreenLock: false,

            currentSlide: 0,
            previousSyncSlide: 0,

            resX: 0,
            resY: 0,

            baseResX: 0,
            baseResY: 0,

            isResReady: false,
            callbackOnResReady: [],

            isMobileDevice: NavigatorUtils.isMobile(),
            isLandscape: false,
            //Animation Data============================
            stopAnimation: false,
            start: 0,
            timeDivisor: 0,
            leftValue: 0,
            difference: 0
            //==========================================
        };
    },

    computed: {
        isLeftArrowVisible() {
            return (this.currentSlide > 0 && this.showArrows === true);
        },

        isRightArrowVisible() {
            return (this.currentSlide + 1 < this.progressiveReveal && this.showArrows === true);
        },

        containerStyle() {
            if (isFullScreen()) {
                let w = this.$refs.carouselContainer.clientWidth;
                let h = this.$refs.carouselContainer.clientHeight;
                let factor = Math.min(screen.width / w, screen.height / h);
                let left = 0;

                if (this.$refs.carouselContainer.mozRequestFullScreen) {
                    left = (screen.width - Math.round(w * factor)) / 2;
                }

                return {
                    width: Math.round(w * factor) + 'px',
                    height: Math.round(h * factor) + 'px',
                    left: left + 'px'
                };
            }

            return {
                width: this.resX + 'px',
                height: this.resY + 'px'
            };
        },

        sliderStyle() {
            return {
                width: (this.slideList.length * this.resX) + 'px',
                height: this.resY + 'px'
            };
        },

        isFullScreenSupported() {
            let container = this.$el;

            return container.requestFullScreen || container.webkitRequestFullScreen || container.mozRequestFullScreen || container.msRequestFullScreen;
        }
    },
 
    methods: {
        switchFullScreen() {
            if (isFullScreen()) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                if (this.$refs.carouselContainer.requestFullScreen) {
                    this.$refs.carouselContainer.requestFullScreen();
                } else if (this.$refs.carouselContainer.webkitRequestFullScreen) {
                    this.$refs.carouselContainer.webkitRequestFullScreen();
                } else if (this.$refs.carouselContainer.mozRequestFullScreen) {
                    this.$refs.carouselContainer.mozRequestFullScreen();
                } else if (this.$refs.carouselContainer.msRequestFullScreen) {
                    this.$refs.carouselContainer.msRequestFullScreen();
                }
            }
        },

        fullscreenSwitched() {
            if (isFullScreen()) {
                return;
            }

            setTimeout(() => {
                this.calcResX();
                this.$refs.carouselSlider.style.left = -(this.resX * this.currentSlide) + 'px';
                this.$refs.carouselContainer.style.width = this.resX + 'px';
                this.$refs.carouselContainer.style.height = this.resY + 'px';
                this.$refs.carouselContainer.style.left = 0;
            }, 1000);
            
        },

        checkProgressiveReveal(index) {
            return (index <= this.progressiveReveal);
        },

        moveStart() {
            this.mouseDown = true;
            this.leftLocation = Number(this.$refs.carouselSlider.style.left.replace('px', ''));
        },

        moveStop() {
            if (this.mouseDown) {
                this.mouseDown = false;
                this.calculateSlide();
            }       
        },

        mouseLeave() {
            this.showFullscreenOn(false);
            this.showArrows = false;
            this.moveStop();
        },

        mouseOver() {
            this.showFullscreenOn(true);
            this.showArrows = true;
        },

        physicalAnimation() {
            this.registerOnResReady(() => {
                this.stopAnimation = true;
                let gotoValue = -1 * this.currentSlide * this.resX;
                this.leftValue = Number(this.$refs.carouselSlider.style.left.replace('px', ''));
                let startValue = this.leftValue;
                this.difference = gotoValue - startValue;

                this.start = performance.now();
                let self = this;

                this.timeDivisor = 300;
                this.stopAnimation = false;
                requestAnimationFrame(this.animate);
            });
        },

        animate(time) {
            if (this.stopAnimation === true) {
                return;
            }

            let timeFraction = (time - this.start) / this.timeDivisor;
            
            if (timeFraction > 1) {
                timeFraction = 1;
            }
            
            let progress = Math.pow(timeFraction, 2);
            let changeValue = (this.leftValue + progress * this.difference);
            this.$refs.carouselSlider.style.left = changeValue + 'px';
            
            if (timeFraction < 1) {
                requestAnimationFrame(this.animate);
            }
        },

        registerOnResReady(callback) {
            if (!callback) {
                return;
            }

            if (this.isResReady) {
                callback();
            } else {
                this.callbackOnResReady.push(callback);
            }
        },

        showFullscreenOn(newVal) {
            if (!this.fullscreenLock) {
                this.showFullscreen = newVal;
            }
        },

        changeSlide(newVal) {
            if (newVal >= 0 && newVal <= this.progressiveReveal) {
                this.$emit('syncSlideEvent', false);
                this.currentSlide = newVal;
                this.physicalAnimation();
            }
        },

        changeSlideSync(newVal) {
            if (newVal >= 0 && newVal <= this.slideList.length) {
                this.currentSlide = newVal;
                this.physicalAnimation();
            }
        },

        calculateSlide() {
            let leftValue = Number(this.$refs.carouselSlider.style.left.replace('px', ''));              
            let potentialSlide;

            if ((typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)) {
                if (this.leftLocation > leftValue) {
                    potentialSlide = this.currentSlide + 1;
                } else if (this.leftLocation < leftValue) {
                    potentialSlide = this.currentSlide - 1;
                }
            } else {
                potentialSlide = Math.round((-leftValue) / this.resX);
            }

            if (potentialSlide > -1 && potentialSlide < this.progressiveReveal && potentialSlide !== this.currentSlide) {
                this.$emit('syncSlideEvent', false);
                this.currentSlide = potentialSlide;
            }

            if (this.leftLocation !== leftValue) {
                this.physicalAnimation();
            }
        },

        calcResX() {
            if (NavigatorUtils.isMobile()) {
                this.resXPhone();
            } else {
                this.resXPC();
            }

             this.isResReady = true;
        },

        resXPC() {
            let potentialHeight = (this.baseResY / this.baseResX) * window.innerWidth;

            if (isFullScreen()) {
                let w = this.$refs.carouselContainer.clientWidth;
                let h = this.$refs.carouselContainer.clientHeight;
                let factor = Math.min(screen.width / w, screen.height / h);

                this.resX = Math.round(w * factor);
            } else if (potentialHeight < (window.innerHeight - 210)) {
                this.resX = window.innerWidth;
            } else {
                this.resX = ((window.innerHeight - 210) / (this.baseResY / this.baseResX));
            }

            this.resY = (this.baseResY / this.baseResX) * this.resX;
        },

        resXPhone() {
            let screenWidth;
            let screenHeight;

            if (window.innerWidth > window.innerHeight) {
                screenWidth = window.innerWidth;
                screenHeight = window.innerHeight;
            } else {
                screenWidth = window.innerHeight;
                screenHeight = window.innerWidth;
            }

            if (this.isLandscape) {                   
                let potentialHeight = (this.baseResY / this.baseResX) * screenWidth;

                if (potentialHeight < screenHeight) {
                    this.resX = screenWidth;
                } else {
                    this.resX = (screenHeight / (this.baseResY / this.baseResX));
                }
            } else {
                this.resX = screenHeight;
            }

            this.resY = (this.baseResY / this.baseResX) * this.resX;

            window.scrollTo(0,0);
        },

        moveTouch(event) {
            if (this.mouseDown) {
                this.$refs.carouselSlider.style.left = ((event.changedTouches[0].clientX - this.mouseLocation) + this.leftLocation) + 'px';
            }
        },

        stopScroll(event) {
            event.preventDefault();
        },

        startTouch(event) {
            if (event.type === 'touchstart' && event.touches.length === 1) {
                this.mouseLocation = event.touches[0].clientX;
                this.moveStart();
            }
        },

        imageStyle(slide) {
            let width;

            if (isFullScreen()) {
                let w = this.$refs.carouselContainer.clientWidth;
                let h = this.$refs.carouselContainer.clientHeight;
                let factor = Math.min(screen.width / w, screen.height / h);

                width = Math.round(w * factor);
            } else {
                width = this.resX;
            }

            return {
                backgroundImage: 'url(' + slide.url + ')',
                backgroundSize: 'contain',
                width: width + 'px'
            };
        }
    },

    created() {
        document.onmousemove = (event) => {
            if (this.mouseDown === false) {
                this.mouseLocation = event.clientX;
            } else {
                this.$refs.carouselSlider.style.left = ((event.clientX - this.mouseLocation) + this.leftLocation) + 'px';
            }
        };
        
        window.onresize = () => {
            this.calcResX();
            this.$refs.carouselSlider.style.left = -(this.resX * this.currentSlide) + 'px';

            // Mozilla support
            if (isFullScreen()) {
                let w = this.$refs.carouselContainer.clientWidth;
                let h = this.$refs.carouselContainer.clientHeight;
                let factor = Math.min(screen.width / w, screen.height / h);
                let left = (screen.width - Math.round(w * factor)) / 2;

                this.$refs.carouselContainer.style.width = Math.round(w * factor) + 'px';
                this.$refs.carouselContainer.style.height = Math.round(h * factor) + 'px';

                if (this.$refs.carouselContainer.mozRequestFullScreen) {
                    this.$refs.carouselContainer.style.left = left + 'px';
                }
            }
        };

        document.addEventListener('webkitfullscreenchange', this.fullscreenSwitched, false);
        document.addEventListener('mozfullscreenchange', this.fullscreenSwitched, false);
        document.addEventListener('fullscreenchange', this.fullscreenSwitched, false);
        document.addEventListener('MSFullscreenChange', this.fullscreenSwitched, false);
    },

    mounted() {
        document.onkeydown = (e) => {
            e = e || window.event;
            if (e.keyCode === '37') {
            // left arrow
                this.changeSlide(this.currentSlide - 1);
            } else if (e.keyCode === '39') {
            // right arrow
                this.changeSlide(this.currentSlide + 1);
            }
        }

        window.addEventListener("orientationchange", () => {
            this.isLandscape = window.orientation !== 0;
        });

        this.isLandscape = window.orientation !== 0;

        // In Firefox full screen must be set to the parent of the canvas
        // to allow resizing the canvas for correct aspect ratio
        if (this.$refs.carouselContainer.mozRequestFullScreen) {
            this.$refs.carouselContainer.mozRequestFullScreen = function() {
                this.parentNode.mozRequestFullScreen.apply(this.parentNode, arguments);
            };
        }
    },

    watch: {
        slideList(newVal) {
            var self = this;
            var img = new Image();

            this.isResReady = false
            
            img.addEventListener('load', function() {
                self.baseResX = this.naturalWidth;
                self.baseResY = this.naturalHeight;
                self.calcResX();
                self.calculateSlide();
            });
            img.src = newVal[0].url;
        },

        presentation(newVal) {
            this.currentSlide = 0;
        },

        currentSlide(newVal) {
            this.$emit('calculatedSlide', newVal);
        },

        syncSlideNum(newVal) {
            if (this.syncSlide) {
                this.changeSlideSync(newVal);
            }
        },

        syncSlide(newVal) {
            if (newVal) {
                this.changeSlideSync(this.syncSlideNum);
            }
        },

        isResReady() {
            for(let callback of this.callbackOnResReady) {
                callback();
            }
        }            
    }
};

</script>

<style lang="scss">

.carouselScreen {
    overflow:hidden;
    z-index: 9999;
    background-color: #000;
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0px;
    left: 0px;
    justify-content: center;
    display: flex;
    -webkit-overflow-scrolling: touch;
}

.carousel {
    cursor: pointer;
    position: relative;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-drag: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    overflow: hidden;

    .image-container{
        cursor: pointer;
        overflow-x: visible;
        display: flex;
        position: relative;

        .images{
            cursor: pointer;
            position: relative;
        }
    }

    .fullscreenButton{
        margin-right: .3em;
        padding: .3em;
        right: 0px;
        top: 0px;
        position: absolute;
        background-color: rgba(0, 0, 0, 0.5);

        img{
            fill: #fff;
            width: 1.5em;
            height: 1.5em;
        }
    }
    .arrowButtonLeft{
        position: absolute;
        background-color: rgba(0, 0, 0, 0.5);
        top: calc(50% - 2.2em);
        border-radius: 50%;
        transform: rotate(270deg);
        left: 3px;
        width:48px;
        height:48px;

        img{
            fill: #fff;
            width:48px;
            height:48px;
        }
    }
    .arrowButtonRight{
        position: absolute;
        background-color: rgba(0, 0, 0, 0.5);
        top: calc(50% - 2.2em);
        right: 3px;
        border-radius: 50%;
        width:48px;
        height:48px;
        transform: rotate(90deg);

        img{
            fill: #fff;
            width:48px;
            height:48px;
            margin-right:5px;
        }
    }
}

.fade-enter-active, .fade-leave-active {
    transition: opacity .5s
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0
}

</style>



// WEBPACK FOOTER //
// Carousel.vue?7d3638e9